export const getStoreNumbers: any = (data: any) => {
  return data
    ?.map((store: any) => store.storeNumber)
    .sort((a: any, b: any) => a - b);
};
